import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import AssetQuantityField from "src/views/inventory/requests/AssetQuantityField";

export default function DuplicateRackLocationsModal({ index, rackLocations, onClose, onDuplicate }) {
  const [locationsToAdd, setLocationsToAdd] = useState(1);

  const handleSubmit = () => {
    const count = Number(locationsToAdd) || 0;

    if (typeof index !== "number" || count < 1 || !rackLocations[index]) {
      onClose();
      return;
    }

    const sourceLocation = rackLocations[index];

    const duplicates = Array.from({ length: count }, () => ({
      ...sourceLocation,
    }));

    const newLocations = [
      ...rackLocations.slice(0, index + 1),
      ...duplicates,
      ...rackLocations.slice(index + 1),
    ];

    onDuplicate(newLocations);
    onClose();
  };

  const isSubmitDisabled = (Number(locationsToAdd) || 0) < 1;

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box position="relative">
          <Typography fontSize={22} fontWeight={500} color="text.primary" align="center">
            Duplicate Locations
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: "absolute", right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom align="center">
          How many total locations would you like to add?
        </Typography>
        <Box mt={4} display="flex" justifyContent="center">
          <AssetQuantityField
            quantity={locationsToAdd}
            onChange={setLocationsToAdd}
            quantityProps={{
              label: "Total Locations",
              style: { minWidth: 160 },
              autoFocus: true,
              InputLabelProps: {
                shrink: true,
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={isSubmitDisabled}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
